export enum LockStatus {
    LOCKED = 'LOCKED',
    SOFT_LOCKED = 'SOFT_LOCKED',
    UNLOCKED = 'UNLOCKED',
}
